import React, { useEffect } from 'react';
import { RootState, useAppDispatch, useAppSelector } from '@/reduxStore/rootReducer';
import {
    fetchClientRoles,
    fetchRoles,
    getCurrentUserRoles,
    getUserPermissions,
} from '@/reduxStore/slices/rolesSlice';
import { setPending } from '@/reduxStore/slices/rolesSlice';
import LoadingPage from '@/pages/LoadingPage/LoadingPage';
import { useAuth0 } from '@auth0/auth0-react';
import { clientViewService } from '@/helpers/clientViewService';

const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    const { isAuthenticated, isLoading } = useAuth0();

    const rolesMap = useAppSelector((state: RootState) => state.roles.rolesMap);
    const userPermissions = useAppSelector((state: RootState) => state.roles.userPermissions);
    const isPending = useAppSelector((state: RootState) => state.roles.isPending);
    const selectedClientId = clientViewService.getSelectedClientId();

    useEffect(() => {
        if (isLoading) return;
        if (!isAuthenticated) {
            dispatch(setPending({ isPending: false })); // set pending false
        } else {
            if (selectedClientId) {
                dispatch(fetchClientRoles(selectedClientId));
            }
            dispatch(fetchRoles());
            dispatch(getCurrentUserRoles());
            dispatch(getUserPermissions());
        }
    }, [isAuthenticated, isLoading]);

    if (isPending) {
        return <LoadingPage />;
    }

    return <>{children}</>;
};

export default PermissionsProvider;
